import { ProductRules } from "lcm-iot-commons";

class ProductEndressHauserConnectedAssetRules extends ProductRules {
  connectedAsset() {
    return true;
  }
}

export default ProductEndressHauserConnectedAssetRules;
